<script lang="ts">
  /**
   * One checkbox row in a meal section. Grams shown are the API's effective
   * grams when selected (already split across several picks), otherwise the
   * plan grams. The small line shows cooked weight when the item has one.
   */
  import Icon from './Icon.svelte';
  import type { DayItem } from '../lib/types';

  let {
    item,
    split = false,
    disabled = false,
    ontoggle,
  }: { item: DayItem; split?: boolean; disabled?: boolean; ontoggle: (id: string) => void } = $props();

  let grams = $derived(item.selected ? item.gramsEffective : item.grams);
  let cooked = $derived(item.selected ? item.gramsCookedEffective : item.gramsCooked);
</script>

<button
  type="button"
  class="opt"
  class:on={item.selected}
  role="checkbox"
  aria-checked={item.selected}
  disabled={disabled}
  onclick={() => ontoggle(item.id)}
>
  <span class="box"><Icon name="check" /></span>
  <span class="name">{item.name}</span>
  <span class="g num" class:split={item.selected && split}>
    {Math.round(grams)} g
    {#if cooked !== null && cooked !== undefined}<small>{Math.round(cooked)} g kypsänä</small>{/if}
  </span>
</button>

<style>
  .opt {
    display: grid;
    grid-template-columns: 26px 1fr auto;
    gap: 10px;
    align-items: center;
    width: 100%;
    text-align: left;
    padding: 11px 14px;
    border-bottom: 1px solid var(--viisi-line);
  }
  .opt:last-child { border-bottom: 0; }
  .opt:disabled { cursor: progress; }
  .box {
    width: 22px;
    height: 22px;
    border-radius: 7px;
    border: 1.5px solid var(--viisi-ink-3);
    display: grid;
    place-items: center;
  }
  .box :global(svg) { width: 14px; height: 14px; display: none; }
  .opt.on .box { background: var(--viisi-accent); border-color: var(--viisi-accent); color: var(--viisi-accent-ink); }
  .opt.on .box :global(svg) { display: block; }
  .name { font-size: 14px; }
  .opt.on .name { font-weight: 600; }
  .g {
    font-family: var(--viisi-font-display);
    font-weight: 700;
    font-size: 14px;
    color: var(--viisi-ink-2);
    min-width: 46px;
    text-align: right;
    white-space: nowrap;
  }
  .g small {
    font-family: var(--viisi-font-body);
    font-size: 10.5px;
    display: block;
    font-weight: 500;
    color: var(--viisi-ink-3);
  }
  .opt.on .g { color: var(--viisi-ink); }
  .g.split { color: var(--viisi-accent); }
</style>
